// TODO: We will migrate all checkout steps to this file. Currently the steps are scattered and difficult to manage. We need to put them all in one place.
export default {
  // ID verification
  id_verification_sau: 'personal_data_verification',
  id_verification_sau_confirm: 'id_verification_confirm',
  id_verification_are: 'uae_id_verification',
  id_verification_routing: 'id_verification_routing',
  id_verification_nafath_waiting: 'nafath_id_verification_waiting',
  ID_VERIFICATION_UQUDO: 'init-uqudo',
  ID_VERIFICATION_UQUDO_INSTANT_APP_LINK:
    'uae_uqudo_id_verification_instant_app',
  // Payment selection step - Apply for [payment link & single payment]
  payment_options_selection: 'payment_options_selection',
  // Pay by later steps
  pay_by_later_confirmation: 'confirmation',
  pay_by_later_require_payment_method: 'require_payment_method',
  // Pay by instalment steps
  pay_by_instalment_confirmation: 'confirmation_instalment',
  pay_by_instalment_charge_down_payment: 'charge_down_payment',
  // Pay now
  pay_now_confirmation: 'confirmation_pay_now',
  pay_now_charge_payment: 'charge_pay_now_payment',
  // Risk step
  risk_consult_response_handling: 'risk_consult_response_handling',
  risk_consult_response_handling_3rd_fraud_check:
    'risk_consult_response_handling_3rd_fraud_check',
  // Ivr steps
  ivr_confirmation: 'IVR_confirmation',
  ivr_confirmed: 'IVR_confirmed',
  ivr_waiting: 'IVR_WAITING',
  // kyc step
  kyc_processing: 'kyc_processing',
  // dues & overdues step
  OVERDUES_CONFIRMATION: 'overdues_confirmation',
  EARLY_SETTLEMENT_CONFIRMATION: 'early_settlement_confirmation',
  // Underwriting step
  EVALUATE_ORDER_CREDIT: 'evaluate_order_credit',
  REATTEMPT_EVALUATE_ORDER_CREDIT: 'reattempt_evaluate_order_credit',
  // Finish step
  FINISH: 'finish',
  FRAUD_LEANTECH_STEPUP: 'fraud_leantech_stepup',
  PREPARE_NECESSARY_DATA_STEP: 'prepare_necessary_data_step',
  // Nova
  FINANCE_CHOOSE_PLAN: 'financing_order_routing',
  FINANCE_REVIEW: 'reviewing_document',
  // Uae KYC
  ID_VERIFICATION_UAE_KYC: 'uae_kyc_processing',
  POST_LOGIN_IVR_CONFIRMATION: 'IVR_confirmation_post_login',
  POST_LOGIN_IVR_WAITING: 'IVR_waiting_post_login',
}
